import { useEffect, useRef } from 'react';
import {Title} from '../common/component_common.js';

export const PageDocumentNapi = ({title, url}) =>
{
    const hrefCur = useRef('');
    useEffect( () =>
    {
        const idx = window.location.href.indexOf('/#');
        const sliceStr = window.location.href.substring(0, idx);

        hrefCur.current = sliceStr;
    }, [window.location.href]);

    return (
        <>
            <div className="d-flex flex-wrap">
                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12">
                    <Title title={title}></Title>
                </div>
                <div className="d-flex full-iframe">
                    <iframe src={`${hrefCur.current}${url}`} title={title}></iframe>
                </div>
            </div>
        </>
    )
}